// ---------- PageFooter ----------
import { Zap } from "lucide-react";

function PageFooter() {
    return (
        <footer className="border-t border-gray-200 bg-white">
            <div className="px-4 sm:px-6 lg:px-8 py-8 grid grid-cols-1 sm:grid-cols-3 gap-6 text-sm">
                <div>
                    <div className="flex items-center gap-2 mb-2">
                        <Zap className="h-5 w-5 text-indigo-600" />
                        <span className="font-semibold">EnergyChain</span>
                    </div>
                    <p className="text-gray-500">
                        Market intelligence for energy production—compare output, plans, and capacity at a glance.
                    </p>
                </div>
                <div>
                    <div className="font-medium text-gray-900 mb-2">Product</div>
                    <ul className="space-y-1">
                        <li><a href="/marketplace" className="text-gray-600 hover:text-gray-900">Marketplace</a></li>
                        <li><a href="/analytics" className="text-gray-600 hover:text-gray-900">Analytics</a></li>
                        <li><a href="/companies" className="text-gray-600 hover:text-gray-900">Companies</a></li>
                    </ul>
                </div>
                <div>
                    <div className="font-medium text-gray-900 mb-2">Resources</div>
                    <ul className="space-y-1">
                        <li><a href="/docs" className="text-gray-600 hover:text-gray-900">Docs</a></li>
                        <li><a href="/support" className="text-gray-600 hover:text-gray-900">Support</a></li>
                        <li><a href="/privacy" className="text-gray-600 hover:text-gray-900">Privacy</a></li>
                    </ul>
                </div>
            </div>
            <div className="px-4 sm:px-6 lg:px-8 py-4 text-xs text-gray-500 border-t">
                © {new Date().getFullYear()} EnergyChain. All rights reserved.
            </div>
        </footer>
    );
}

export default PageFooter;
